import { BadgeCheck } from "lucide-react";

/**
 * "Recommended by DopeMedia" badge — surfaces curated/trusted users.
 *
 * Variants:
 *   - "pill" (default): inline lime pill, fits next to a name
 *   - "ribbon": absolute-positioned ribbon for cards (top-right)
 *   - "banner": full-width subtle banner for hero sections
 */
const RecommendedBadge = ({ variant = "pill", className = "" }) => {
  if (variant === "ribbon") {
    return (
      <div
        className={`absolute top-3 right-3 z-10 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#CCFF00] text-black text-[10px] font-bold uppercase tracking-wider shadow-lg ${className}`}
        data-testid="recommended-badge"
        title="Recommended by DopeMedia"
      >
        <BadgeCheck className="w-3 h-3" fill="black" />
        <span>Recommended by DopeMedia</span>
      </div>
    );
  }
  if (variant === "banner") {
    return (
      <div
        className={`flex items-center gap-2 px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#CCFF00]/15 via-[#CCFF00]/8 to-transparent border border-[#CCFF00]/30 ${className}`}
        data-testid="recommended-badge"
      >
        <BadgeCheck className="w-5 h-5 text-[#CCFF00]" />
        <span className="text-sm font-bold text-white">
          Recommended by <span className="text-[#CCFF00]">DopeMedia</span>
        </span>
      </div>
    );
  }
  // pill
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#CCFF00]/15 border border-[#CCFF00]/40 text-[#CCFF00] text-[10px] font-bold uppercase tracking-wider ${className}`}
      data-testid="recommended-badge"
      title="Recommended by DopeMedia"
    >
      <BadgeCheck className="w-3 h-3" />
      <span>Recommended by DopeMedia</span>
    </span>
  );
};

export default RecommendedBadge;
